import React from 'react';

import { useMountedState } from '@gogame/hooks-ts';

import { MarketingPlanningSocketContext } from './MarketingPlanningSocketContext';
import {
  useSocketBlur,
  useSocketFocus,
  useSocketDraft,
  useSocketFinalize,
  useSocketDiscard,
  useSocketRestore,
  useSocketGoToGrid,
  useSocketRoom,
  useSocketUpdateConnectedToRoom,
} from './hooks';

export const MarketingPlanningSocketsProvider = ({ children }) => {
  const [connected, setConnected] = useMountedState([]);
  const [highlighted, setHighlighted] = useMountedState({});

  useSocketRoom();
  useSocketDraft();
  useSocketFinalize();
  useSocketDiscard();
  useSocketRestore();
  useSocketGoToGrid();

  useSocketUpdateConnectedToRoom(
    ({ connected }) => {
      setConnected(connected);
    },
    [setConnected]
  );
  useSocketBlur(
    (received) => {
      // eslint-disable-next-line no-unused-vars
      const { [received.path]: _, ...other } = highlighted;
      setHighlighted(other);
    },
    [setHighlighted, highlighted]
  );

  useSocketFocus(
    (received) => {
      setHighlighted({ ...highlighted, [received.path]: received });
    },
    [setHighlighted, highlighted]
  );

  return (
    <MarketingPlanningSocketContext.Provider
      value={{ connected, setConnected, highlighted }}
    >
      {children}
    </MarketingPlanningSocketContext.Provider>
  );
};
